module.exports = __webpack_public_path__ + "img/46.5f05ab2e.jpg";